<template>
<div class="mBanner">
    <van-swipe :autoplay="3000" v-if="bannerList.length">
        <van-swipe-item v-for="(obj, index) in bannerList" :key="index" @click="goToTab(obj)">
            <img v-lazy="obj.adurl" :alt="obj.adtitle" class="banner-img">
        </van-swipe-item>
    </van-swipe>
</div>
</template>

<script>
import {getAdConfig} from 'api/systemApi'
import {mapGetters, mapActions} from 'vuex'
export default {
    name: 'mBanner',
    data() {
        return {
            bannerList: []
        }
    },
    mounted() {
        this.getBannerList()
    },
    methods: {
        getBannerList() {
            this.setLoading(true)
            getAdConfig({
                data: {
                    adcode: 'N04'
                },
                success: data => {
                    this.setLoading(false)
                    this.bannerList = data.data.content
                },
                error: data => {
                    this.setLoading(false)
                    this.$toast.fail(data.msg)
                }
            })
        },
        goToTab(obj) {
            window.location.href = obj.clickurl
        },
        ...mapActions(['setLoading'])
    },
    filters: {},
    watch: {},
    computed: {
        ...mapGetters([])
    },
    components: {}
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
.mBanner {
    .van-swipe {
        height: 3rem;
    }
    .banner-img{
        width: 100%;
        height: 3rem;
    }
}
</style>